{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/TIMED_GET_UP_AND_GO",
	"name": "TIMED_GET_UP_AND_GO",
	"language": "fr-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "Timed Get Up and Go",
	"purpose": "Mesure la mobilité et le risque de chute",
	"description": "Mesurer (en secondes) le temps nécessaire pour se lever d’une chaise, marcher 3 mètres à un rythme confortable, faire demi-tour, revenir et s’asseoir.",
	"item": [
		{
			"linkId": "638-instructions",
			"text": "Le patient à examiner est assis sur une chaise avec un dossier et les bras en appui sur les accoudoirs. On lui demande de se lever, de marcher trois mètres jusqu’à une ligne ou un repère, de se retourner de 180°, de revenir vers la chaise et de s’asseoir. L’utilisation d’un moyen d’aide (par exemple canne ou tribune) est autorisée. Ce moyen d’aide peut être tenu en main par le patient à l’entame du test. Le début et la fin du chronométrage se font lorsque le patient est assis, dos en appui sur le dossier de la chaise. Un essai pratique est recommandé pour familiariser le patient au test.",
			"type": "display"
		},
		{
			"linkId": "90200",
			"text": "Combien de secondes faut-il pour effectuer le Timed Get Up and Go?",
			"type": "integer",
			"required": true,
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-unit",
					"valueCoding": {
						"system": "http://unitsofmeasure.org",
						"code": "s",
						"display": "seconds"
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/minValue",
					"valueInteger": 1
				}
			]
		}
	]
}
